class DsfDataForm {
  constructor(data, validators) {
    this.data = data;
    this.validators = validators;
    this._errors = {};
    Object.keys(this.data).forEach((key) => {
      const resultKey = key;
      this._errors[resultKey] = {
        message: "",
        isInvalid: false
      };
    });
  }
  get errors() {
    return this._errors;
  }
  hasErrors(field) {
    return !!this._errors[field] && this._errors[field].isInvalid;
  }
  getErrors(field) {
    if (this.hasErrors(field)) {
      const error = this._errors[field];
      return error.message;
    }
    return "";
  }
  setValue(key, value) {
    this.data[key] = value;
    this.clearValidations(key);
    this.validate(key);
  }
  clearValidations(field) {
    this._errors[field].isInvalid = false;
    this._errors[field].message = "";
  }
  validate(field) {
    this.validators[field].forEach((validator) => {
      const isInvalid = validator.isInvalid(this.data[field]);
      if (isInvalid) {
        this._errors[field].message = validator.errorMessage;
        this._errors[field].isInvalid = true;
      }
    });
  }
  get isFormInvalid() {
    const formKeys = Object.keys(this._errors);
    return formKeys.some((key) => {
      const resultKey = key;
      const field = this._errors[resultKey];
      return field.isInvalid;
    });
  }
}
export {
  DsfDataForm
};
